export default __webpack_public_path__ + "static/media/1.a6e545fb.jpg";